const phoneNumbers = require('libphonenumber-js/max');

const assert = require('@barchart/common-js/lang/assert'),
	Enum = require('@barchart/common-js/lang/Enum');

module.exports = (() => {
	'use strict';

	/**
	 * The mode of transport for a message.
	 *
	 * @public
	 * @extends {Enum}
	 * @param {String} code
	 * @param {Function} validator
	 * @param {Function} formatter
	 */
	class Transport extends Enum {
		constructor(code, validator, formatter) {
			super(code, code);

			assert.argumentIsRequired(validator, 'validator', Function);
			assert.argumentIsRequired(formatter, 'formatter', Function);

			this._validator = validator;
			this._formatter = formatter;
		}

		/**
		 * Validates a string is a valid address.
		 *
		 * @public
		 * @param {String} candidate
		 * @returns {Boolean}
		 */
		validate(candidate) {
			assert.argumentIsRequired(candidate, 'candidate', String);

			return this._validator(candidate);
		}

		/**
		 * Returns a properly-formatted version of a valid address.
		 *
		 * @public
		 * @param {String} candidate
		 * @returns {String}
		 */
		format(candidate) {
			if (!this.validate(candidate)) {
				throw new Error(`Unable to format [ ${candidate} ] as an address for [ ${this.code} ]`);
			}

			const formatted = this._formatter(candidate);

			if (formatted === null) {
				throw new Error(`Unable to format [ ${candidate} ] as an address for [ ${this.code} ]`);
			}

			return formatted;
		}

		/**
		 * Returns the {@link Transport} associated with a specific code.
		 *
		 * @public
		 * @static
		 * @param {String} code
		 * @returns {Transport|null}
		 */
		static parse(code) {
			return Enum.fromCode(Transport, code);
		}

		/**
		 * SMS.
		 *
		 * @public
		 * @static
		 * @returns {Transport}
		 */
		static get SMS() {
			return sms;
		}

		toString() {
			return `[Transport (code=${this.code})]`;
		}
	}

	const sms = new Transport('SMS', validatePhone, formatPhone);

	function parsePhone(candidate) {
		let parsed;

		try {
			parsed = phoneNumbers.parsePhoneNumber(candidate, { defaultCountry: 'US', extract: false }) || null;
		} catch (e) {
			parsed = null;
		}

		return parsed;
	}

	function checkParsed(parsed) {
		return parsed !== null && parsed.isPossible() && parsed.isValid();
	}

	function validatePhone(candidate) {
		let actualParse = parsePhone(candidate);
		let adjustParse;

		if (!candidate.startsWith('+')) {
			adjustParse = parsePhone(`+${candidate}`);
		} else {
			adjustParse = null;
		}

		return checkParsed(actualParse) || checkParsed(adjustParse);
	}

	function formatPhone(candidate) {
		let actualParse = parsePhone(candidate);
		let adjustParse;

		if (!candidate.startsWith('+')) {
			adjustParse = parsePhone(`+${candidate}`);
		} else {
			adjustParse = null;
		}

		let parseToUse;

		if (checkParsed(actualParse)) {
			parseToUse = actualParse;
		} else if (checkParsed(adjustParse)) {
			parseToUse = adjustParse;
		} else {
			parseToUse = null;
		}

		if (parseToUse !== null) {
			return parseToUse.format('E.164');
		} else {
			return null;
		}
	}

	return Transport;
})();
